import { useEffect, useRef } from 'react';
import { usePopup } from './GlobalPopupWrapper';
import eventBus from '../../utils/eventBus';

const GlobalAuthTrigger = () => {
    const { openPopup } = usePopup();
    const listenerRef = useRef(null);

    useEffect(() => {
        const handler = payload => {
            openPopup({ type: payload?.type || 'login' });
        };
        eventBus.on('auth:require', handler);
        listenerRef.current = () => eventBus.off('auth:require', handler);
        return () => {
            if (listenerRef.current) listenerRef.current();
        };
    }, [openPopup]);

    return null;
};

export default GlobalAuthTrigger;
